const CONSIDERATIONS = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Distance to Downtown Highlands',
    desc: 'Most vacation rentals in Highlands, NC are within 5 to 10 minutes of downtown. That said, it\'s worth checking the specific location — some properties are closer to the town center, while others are more remote. If you plan to walk to dinner or browse the shops on Main Street, proximity matters.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Privacy and Seclusion',
    desc: 'One of the main reasons people choose Highlands over a hotel is the privacy a cabin provides. Look for properties described as "secluded" or "wooded" — and check the listing photos carefully. Some cabins are closer to neighbors than the listing implies.',
  },
  {
    icon: 'ri-landscape-line',
    title: 'Mountain Setting and Views',
    desc: 'Highlands is surrounded by beautiful forest and mountain scenery, but not every rental makes the most of it. Look for covered decks, outdoor seating areas, and properties that are genuinely set within the trees rather than in a cleared lot.',
  },
  {
    icon: 'ri-footprint-line',
    title: 'Pet Friendliness',
    desc: 'If you\'re traveling with a dog, confirm the pet policy before booking. Several vacation rentals in Highlands, NC are pet friendly — Glen Falls Luxury Cabin, Lark Lodge, and Stag Ridge among them — but not all properties allow pets, and some charge additional fees.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Fireplace and Outdoor Living',
    desc: 'A fireplace — especially an outdoor one — can make a Highlands cabin stay significantly more enjoyable, particularly in the shoulder seasons. Highlands evenings can be cool even in summer, and an outdoor fireplace or fire pit adds a lot to the experience.',
  },
  {
    icon: 'ri-group-line',
    title: 'Family Suitability',
    desc: 'If you\'re traveling with kids, look for properties with enough bedrooms, a full kitchen, and outdoor space. Many Highlands cabin rentals accommodate 4 to 8 guests comfortably. Glen Falls Luxury Cabin, for example, sleeps up to 6 and works well for families.',
  },
  {
    icon: 'ri-walk-line',
    title: 'Proximity to Hiking and Waterfalls',
    desc: 'Highlands is surrounded by some of the best waterfall hikes in the Southeast — Glen Falls, Dry Falls, Bridal Veil Falls, and more. If outdoor access is a priority, look for rentals along Falls Drive or near the Nantahala National Forest. Glen Falls Luxury Cabin is within walking distance of the Glen Falls trailhead.',
  },
];

export default function VRWhatToLookForSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Buyer&apos;s Guide</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            What to Look For in a<br /><em className="italic">Highlands Vacation Rental</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-xl mx-auto mt-6">
            Not all cabin rentals in Highlands, NC are created equal. Here are the factors that matter most when choosing where to stay.
          </p>
        </div>

        <div className="space-y-8">
          {CONSIDERATIONS.map((item, idx) => (
            <div key={item.title} className="flex items-start gap-6">
              <div className="shrink-0 flex flex-col items-center">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-white">
                  <i className={`${item.icon} text-[#2D4A3E] text-base`} />
                </div>
                {idx < CONSIDERATIONS.length - 1 && (
                  <div className="w-px flex-1 bg-[#D4CFC7] mt-3 min-h-[32px]" />
                )}
              </div>
              <div className="pb-8">
                <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-2">{item.title}</h3>
                <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
